import React from 'react';

import AppConfig from '../../../utils/appConfig';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import SimpleDateSelector from './SimpleDateSelector';

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('DATE_RANGE_SELECTOR', LOG_LEVELS.DEBUG);
const START_DATE_FIELD_NAME = 'startDate';
const END_DATE_FIELD_NAME = 'endDate';

class DateRange extends React.Component {

    constructor(props) {
        super(props);
        this.selectionHandler = this.selectionHandler.bind(this);
    }

    selectionHandler(keyValue) {
        log.debug('selectionHandler(): keyValue: ', keyValue);
        if(typeof this.props.onChange === 'function') {
            this.props.onChange(keyValue);
        }
    }
    
    render() {
        log.debug('render(): ', this.props);
        let {
            startDate,
            endDate,
            dateFormat,
            startDateLabelkey,
            endDateLabelkey,
            disableStartDate,
            disableEndDate,
            startDateDefaultValue,
            endDateDefaultValue
        } = this.props;

        startDate = typeof startDate === "string" ? startDate: (typeof startDateDefaultValue === "string" ? startDateDefaultValue: '');
        log.debug('render(): startDate: ', startDate);
        endDate = typeof endDate === "string" ? endDate: (typeof endDateDefaultValue === "string" ? endDateDefaultValue: '');
        log.debug('render(): endDate: ', endDate);
        return (
            <div>
                <fieldset>
                    <label><LanguageStringResolver string={startDateLabelkey || 'dateRangeSelector_StartDate'}/></label>
                    <SimpleDateSelector
                        selectionHandler={this.selectionHandler}
                        fieldName={START_DATE_FIELD_NAME}
                        format={dateFormat}
                        value={startDate}
                        extraProps={ {
                                disabled: disableStartDate
                            }
                        }
                    />
                </fieldset>
                <fieldset>
                    <label><LanguageStringResolver string={endDateLabelkey || 'dateRangeSelector_EndDate'}/></label>
                    <SimpleDateSelector
                        selectionHandler={this.selectionHandler}
                        fieldName={END_DATE_FIELD_NAME}
                        format={dateFormat}
                        value={endDate}
                        extraProps={ {
                                disabled: disableEndDate
                            }
                        }
                    />
                </fieldset>
            </div>
        );
    }
}


DateRange.defaultProps = {
    dateFormat: AppConfig.DateTimeConfig.DEFAULT_DATE_FORMAT,
    disableStartDate: false,
    disableEndDate: false,
    onChange: () => {}
}

export default DateRange;
